module.exports = __webpack_public_path__ + "static/media/2.972a434c.png";